<template>
  <div
    :style="customStyle"
    :class="[containerClasses, formGroup ? 'form-group' : '']">
    <label v-if="label !== null" :class="[labelClasses]">
      <i class="m1" :class="[tooltipIcon]" :title="tooltip"
         v-if="tooltip!==null&&tooltipLeft&&!tooltipRight"></i>
      {{ label }}
      <span style="color:red">{{ required ? '*' : '' }}</span>
      <i class="m1" :class="[tooltipIcon]" :title="tooltip" v-if="tooltip!==null&&tooltipRight"></i>
    </label>

    <div :class="[{'input-group': hasSlotSuffix || hasSlotPrefix}]">
      <div :class="[slotClasses]" v-if="hasSlotPrefix">
        <slot name="prefix" v-if="hasSlotPrefix"></slot>
      </div>
      <div style="padding-right: 5px;padding-left: 5px; padding-bottom: 8px; font-size:12px; position: relative;" v-if="enableSearch || enableDBSearch">
        <input
          type="text"
          v-model="filterOptionsSearch"
          class="form-control form-control-sm rounded-right"
          placeholder="Search" aria-label="search"
          aria-describedby="search"
          @keydown.enter.prevent=""
          autocomplete="new-password"
        >
        <span class="icon-inside-sm"><i class="fa fa-search"></i></span>
      </div>
      <select
        class="custom-select"
        :id="`custom-select-${_uid}`"
        :class="[inlineSelectColClass, computedValidationStatus]"
        v-model="cValue"
        :required="required"
        :disabled="disabled"
        :readonly="readOnly"
        @click="onClick"
        @change="onChange"
        @focus="onFocus"
        @blur="onBlur"
        @keypress="onKeyPress"
      >
        <option v-if="showNewOption" value="newOption" @click.prevent="newOptionClicked">{{ newOptionLabel }}</option>
        <hr v-if="showNewOption"/>
        <option v-if="showNullOption" :value="null" :disabled="disableNullOption" :hidden="hideNullOption">{{ nullOptionLabel }}</option>
        <option v-if="showAllOption" :value="allOptionValue" @click.prevent="allOptionClicked"> {{ allOptionLabel }}</option>
        <option v-for="(option, index) in this.enableSearch && !this.enableDBSearch ? filteredOptions : input_options"
          :class="[{'disabled-option': !option.enabled}]"
          :key="'select-option-' + index"
          :value="option.value"
          :disabled="!option.enabled"
        >
          <template v-if="!hasSlotOptionLabel">
            {{ option.label }}
          </template>
          <slot name="optionLabel" :option="providerOptions[option.index]"></slot>
        </option>
      </select>
      <div :class="[slotClasses]" v-if="hasSlotSuffix">
        <slot name="suffix" v-if="hasSlotSuffix"></slot>
      </div>
    </div>
    <small class="form-text text-muted" v-if="helpText">{{ helpText }}</small>
    <div class="valid-feedback" v-if="computedValidationStatus == 'is-valid'" style="display: block !important;">
      <ul>
        <li v-for="(text, index) in validText" :key="_uid+'success_' + index">{{ text }}</li>
      </ul>
    </div>
    <div class="invalid-feedback" v-if="computedValidationStatus == 'is-invalid'" style="display: block !important;">
      <ul>
        <li v-for="(text, index) in invalidText" :key="_uid + 'error_' + index">{{ text }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Vuex from 'vuex'
import {selectorMixin} from './../mixins/index.js';

var timeoutSelectFieldSearch = null;
export default {
  name: "single-select-field",
  mixins: [selectorMixin],
  props: {
    disableNullOption: {
      type: Boolean,
      default: false
    },
    hideNullOption: {
      type: Boolean,
      default: false
    },
    formGroup: {
      type: Boolean,
      default: true
    },
    value: {},
    customStyle: {
      type: String,
      default: null
    },
    inlineSelectColClass: {
      type: String,
      default: 'col'
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    enableSearch: {
      type: Boolean,
      default: false
    },
    enableDBSearch: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: null
    },
    tooltipIcon: {
      type: String,
      default: 'fas fa-question-circle'
    },
    tooltipRight: {
      type: Boolean,
      default: false
    },
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    inLine: {
      type: Boolean,
      default: false
    },
    inlineLabelColClass: {
      type: String,
      default: 'col'
    },
    classes: {
      type: String,
      required: false
    },
    label: {
      type: String,
      default: null
    },
    options: {
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    optionValue: {
      type: String,
      required: true //define prop name for take value
    },
    optionLabel: { // define prop name for take label
      type: String,
      required: true 
    },
    optionFilter: {
      default: null //function to filter
    },
    size: {
      type: String, //sm-lg-md
      default: null
    },
    showNewOption: {
      type: Boolean,
      default: false
    },
    newOptionLabel: {
      type: String,
      default: "New"
    },
    showAllOption: {
      type: Boolean,
      default: false
    },
    allOptionLabel:{
      type: String,
      default: "None"
    },
    allOptionValue:{
      type: String,
      default: null
    },
    showNullOption: {
      type: Boolean,
      default: false
    },
    nullOptionLabel:{
      type: String,
      default: "None"
    }
  },
  watch: {
    value: function(newVal, oldVal){
      if (newVal === undefined) return;
      if(JSON.stringify(newVal) != JSON.stringify(this.cValue)){
        this.cValue = JSON.parse(JSON.stringify(newVal));
      }
    },
    cValue: function(newVal, oldVal){
      this.$emit('input', newVal);
      if(typeof newVal !== 'undefined') {
        this.$emit('onChange', this);
        if(newVal == 'newOption') this.$emit('onNewClick', this);
      }
    }
  },
  computed: {
    input_options() {
      try {
        let options = this.providerOptions.map((option, index) => {
          let adittionalParams = {enabled: typeof option.__enabled!=='undefined'?option.__enabled:true, index: index};
          if (typeof option === 'object' && (option.value != undefined && option.label != undefined)) {
            return { ...option, ...adittionalParams };
          } else if (typeof option === 'object' && (this.optionLabel !== null && this.optionValue !== null)) {
            return { value: option[this.optionValue], label: option[this.optionLabel], ...adittionalParams };
          } else {
            return { value: option, label: option, ...adittionalParams };
          }
        });
        return options;
      } catch (err) {
        return [];
      }
    },
    hasSlotPrefix() {
      return !!this.$slots.prefix;
    },
    hasSlotSuffix() {
      return !!this.$slots.suffix;
    },
    hasSlotOptionLabel(){
      return !!this.$slots.optionLabel;
    },
    slotClasses() {
      return this.hasSlotPrefix ? 'input-group-prepend' : this.hasSlotSuffix ? 'input-group-append' : null;
    }
  },
  mounted() {
    this.filteredOptions = this.input_options;
    this.$emit('onMounted', this);
  },
  methods: {
    open() {
      if ($('.dropdown').find('.dropdown-menu').is(":hidden")){
        $('.dropdown-toggle').dropdown('toggle');
      }
    },
    onKeyPress() {
      this.$emit('onKeyPress', this);
    },
    onBlur() {
      this.$emit('onBlur', this);
    },
    onFocus() {
      this.$emit('onFocus', this);
    },
    onClick() {
      this.$emit('onClick', this);
    },
    onChange(evt){
      //this.$emit('onChange', this);
    },
    newOptionClicked(evt){
      this.$emit('onNewOptionClicked', this);
    },
    allOptionClicked(evt){
      this.$emit('onAllOptionClicked', this);
    }
  },
  data() {
    return {
      filterOptionsSearch: '',
      filteredOptions: [],
      selectedItemLabel: null,
      cValue: this.value ? JSON.parse(JSON.stringify(this.value)) : null,
      isCustom: false, //flag for type of search
    }
  }
}
</script>
<style>

.disabled-option{
  background: #dadada;
}

</style>
